import React from "react";
import { StringWidget } from "./StringWidget";

export function FilePathWidget(props) {

  const actionButtonOptions =
  {
    icon: 'doc',
    action: (value) => {
      alert("TBD");
    }
  };

  return (
    <StringWidget
      isBaseWidgetFor="FilePathWidget"
      actionButtonOptions={actionButtonOptions}
      {...props}
    />
  );
}